const loginSchema = {
    feilds: [
        {
            id: 0,
            name: 'login',
            text: 'TV Login',
            visible: true,
            element: 'label',
            className: [],
            required: false
        }, {
            id: 1,
            name: 'tv_display_name',
            text: 'TV Name',
            visible: true,
            element: 'input',
            required: true,
            input_type: 'email',
            placeholder: 'Username',
            icon: 'user',
            rules: [
                {
                    test: (value) => {
                        return value.length > 0;
                    },
                    message: 'Please Enter Your Username'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: []
        }, {
            id: 2,
            name: 'password',
            text: 'Password',
            visible: true,
            icon: 'lock',
            element: 'input',
            required: true,
            input_type: 'password',
            placeholder: 'Password',
            rules: [
                {
                    test: (value) => {
                        return value.length > 0;
                    },
                    message: 'Please Enter Your Password'
                }
            ],
            errors: [],
            value: null,
            valid: false,
            state: '',
            disable: false,
            className: []
        }, {
            id: 0,
            name: 'button',
            text: 'Sign In',
            visible: true,
            required: false,
            element: 'button',
            input_type: 'button',
            disable: false
        }
    ]
}

export default loginSchema;